/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Table, Tag } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { list } from "../features/userPayment/userPaymentSlice";
const formatDate = (isoString) => {
  const date = new Date(isoString);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  return `${day}/${month}/${year} ${hours}:${minutes}`;
};

const UserPayment = () => {
  const dispatch = useDispatch();
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
    key: "",
    status: "",
  });

  // Fetch data on component mount and pagination change
  useEffect(() => {
    const { current, pageSize } = pagination;
    const skip = (current - 1) * pageSize;
    dispatch(list({ limit: pageSize, skip }));
  }, [dispatch, pagination.current, pagination.pageSize]);

  const { userPayments, total, isLoading } = useSelector(
    (state) => state.userPayments
  );

  const handleTableChange = (pagination) => {
    setPagination({
      ...pagination,
      current: pagination.current,
      pageSize: pagination.pageSize,
    });
  };

  useEffect(() => {
    setPagination((prev) => ({
      ...prev,
      total: total,
    }));
  }, [total]);

  const columns = [
    {
      title: "User",
      key: "user_id",
      render: (record) => {
        return (
          <div>
            <p>
              {record.user_id.first_name} {record.user_id.last_name}
            </p>
          </div>
        );
      },
    },
    {
      title: "Type",
      key: "type",
      render: (record) => {
        return (
          <div>
            <p>{record.type === 'hole-out' ? 'Hole Out' : 'Hole In One'}</p>
          </div>
        );
      },
    },
    {
      title: "Transaction ID",
      dataIndex: "charge_id",
    },
    {
      title: "Amount",
      key: "unit_amount",
      render: (record) => {
        return (
          <div>
            <p>{`${record.currency.toUpperCase()} ${(record.unit_amount / 100).toFixed(2)}`}</p>
          </div>
        );
      },
    },
    {
      title: "Credits",
      dataIndex: "credits",
      render: (record) => {
        return (
          <div>
            <p>{record}</p>
          </div>
        );
      },
    },
    {
      title: "Gateway",
      dataIndex: "payment_gateway",
      render: (record) => {
        return (
          <Tag color={record?.toUpperCase() === 'STRIPE' ? 'green' : 'red'} key={`${Math.random()}`}>
          {record?.toUpperCase() || 'STRIPE'}
        </Tag>
        );
      },
    },
    {
      title: "Date",
      render: (record) => {
        return formatDate(record.createdAt);
        // const date = new Date(record.createdAt);
        // const formattedDate = date.toLocaleDateString("en-US", {
        //   weekday: "long",
        //   year: "numeric",
        //   month: "long",
        //   day: "numeric",
        // });
        // const formattedTime = date.toLocaleTimeString("en-US", {
        //   hour: "2-digit",
        //   minute: "2-digit",
        //   second: "2-digit",
        // });
        // return `${formattedDate}, ${formattedTime}`;
      },
      key: "createdAt",
    },
  ];

  return (
    <div>
      <div className="row-space-between">
        <h3 className="mb-4 title">Payments</h3>
      </div>
      <p> {isLoading} </p>
      <div>
        <Table
          columns={columns}
          dataSource={userPayments}
          rowKey={(record) => record._id}
          onChange={handleTableChange}
          pagination={pagination}
          loading={isLoading}
        />
      </div>
    </div>
  );
};

export default UserPayment;
